module.exports = __webpack_public_path__ + "static/media/loading-img.72c4f218.svg";